// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sounds-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.sounds-section .sounds-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.sounds-section .sounds-wrap .sounds-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  position: relative;
}
.sounds-section .sounds-wrap .sounds-box .text-box {
  width: 100%;
  max-width: 51.25rem;
}
.sounds-section .sounds-wrap .sounds-box .text-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.sounds-section .sounds-wrap .sounds-box .text-box .btn-box {
  margin-top: 3.5rem;
}
.sounds-section .sounds-wrap .sounds-box .img-box {
  width: 100%;
  max-width: 24.25rem;
  height: 100%;
  max-height: 24.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sounds-section .sounds-wrap .sounds-box .img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
@media screen and (max-width: 991.98px) {
  .sounds-section {
    padding: 2.5rem 0;
  }
  .sounds-section .sounds-wrap .sounds-box .text-box {
    max-width: 51.25rem;
  }
  .sounds-section .sounds-wrap .sounds-box .text-box .para-text {
    font-size: 1rem;
  }
  .sounds-section .sounds-wrap .sounds-box .text-box .btn-box {
    margin-top: 2rem;
  }
  .sounds-section .sounds-wrap .sounds-box .img-box {
    max-width: 14rem;
    max-height: 14rem;
  }
}
@media screen and (max-width: 767.98px) {
  .sounds-section {
    padding: 2rem 0;
  }
  .sounds-section .sounds-wrap .sounds-box .text-box {
    max-width: unset;
    padding-left: 3.25rem;
  }
  .sounds-section .sounds-wrap .sounds-box .text-box .para-text {
    font-size: 0.875rem;
  }
  .sounds-section .sounds-wrap .sounds-box .text-box .btn-box {
    margin-top: 1rem;
  }
  .sounds-section .sounds-wrap .sounds-box .img-box {
    max-width: 2.5rem;
    max-height: 2.5rem;
    position: absolute;
    top: 0;
    left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SoundsSection/SoundsStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AACN;AACM;EACE,WAAA;EACA,mBAAA;AACR;AACQ;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AACV;AAEQ;EACE,kBAAA;AAAV;AAIM;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFR;AAIQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAFV;AAQE;EAnDF;IAoDI,iBAAA;EALF;EASM;IACE,mBAAA;EAPR;EASQ;IACE,eAAA;EAPV;EAUQ;IACE,gBAAA;EARV;EAYM;IACE,gBAAA;IACA,iBAAA;EAVR;AACF;AAeE;EA5EF;IA6EI,eAAA;EAZF;EAgBM;IACE,gBAAA;IACA,qBAAA;EAdR;EAgBQ;IACE,mBAAA;EAdV;EAiBQ;IACE,gBAAA;EAfV;EAmBM;IACE,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;EAjBR;AACF","sourcesContent":[".sounds-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .sounds-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .sounds-box {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 1rem;\n      position: relative;\n\n      .text-box {\n        width: 100%;\n        max-width: 51.25rem;\n    \n        .para-text {\n          color: var(--black-1000);\n          font-size: 1.5rem;\n          font-weight: 400;\n          line-height: 1.4;\n        }\n  \n        .btn-box {\n          margin-top: 3.5rem;\n        }\n      }\n\n      .img-box {\n        width: 100%;\n        max-width: 24.25rem;\n        height: 100%;\n        max-height: 24.25rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n          object-position: center;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .sounds-wrap {  \n      .sounds-box {  \n        .text-box {\n          max-width: 51.25rem;\n      \n          .para-text {\n            font-size: 1rem;\n          }\n    \n          .btn-box {\n            margin-top: 2rem;\n          }\n        }\n  \n        .img-box {\n          max-width: 14rem;\n          max-height: 14rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .sounds-wrap {  \n      .sounds-box {  \n        .text-box {\n          max-width: unset;\n          padding-left: 3.25rem;\n      \n          .para-text {\n            font-size: 0.875rem;\n          }\n    \n          .btn-box {\n            margin-top: 1rem;\n          }\n        }\n  \n        .img-box {\n          max-width: 2.5rem;\n          max-height: 2.5rem;\n          position: absolute;\n          top: 0;\n          left: 0;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
